import AbstractToolCollection from "../AbstractToolCollection";
import HelpTool from "../HelpTool";
import NavigateTool from "../NavigateTool";
import SelectTool from "../edit/SelectTool";
import SettingsTool from "./SettingsTool";
import EraseTool from "./EraseTool";
import PlacementTool from "./PlacementTool";
import ShapesTool from "./ShapesTool";
import AddSpeciesTool from "./AddSpeciesTool";
import ImageTool from "./ImageTool";

export default class ToolCollection extends AbstractToolCollection {
    constructor(provider) {
        super(provider);

        this.tools = {
            'select': new SelectTool(this.provider),
            'shapes': new ShapesTool(this.provider),
            'navigate': new NavigateTool(this.provider),
            'placement': new PlacementTool(this.provider),
            'add_species': new AddSpeciesTool(this.provider),
            'erase': new EraseTool(this.provider),
            'image': new ImageTool(this.provider),
            'settings': new SettingsTool(this.provider),
            'help': new HelpTool(this.provider, 'edit'),
        };
    }

    init() {
        this.tools['select'].setButton(window['selectButton']);
        this.tools['shapes'].setButton(window['shapesButton']);
        this.tools['navigate'].setButton(window['navigationButton']);
        this.tools['erase'].setButton(window['eraseButton']);
        this.tools['image'].setButton(window['imageButton']);
        this.tools['settings'].setButton(window['settingsButton']);
        this.tools['help'].setButton(window['helpButton']);

        this.currentTool = this.tools['select'];
        this.currentTool.activate();
    }
}
